module.exports = __webpack_public_path__ + "static/img/12.20cfbf5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/12.jpeg
// module id = SzKQ
// module chunks = 3